import React, { FC } from 'react';
import { Box } from '@bechtel/gds';
import { Ownership, OwnerShipProps } from './ownership';
import { CurrentWeek } from '@bechtel/client-dashboard-common';
import { DashboardHeaderRowStyled } from './styled';

export const DashboardHeader: FC<OwnerShipProps> = (ownerShipProps) => {
  return (
    <DashboardHeaderRowStyled>
      <Box mx={{ sm: '600' }} alignItems={{ sm: 'center' }} flexGrow={{ sm: 1 }}>
        <CurrentWeek></CurrentWeek>
        <Ownership selectedOwnershipLevel = {ownerShipProps.selectedOwnershipLevel} setSelectedOwnershipLevel={ownerShipProps.setSelectedOwnershipLevel}/>
      </Box>
    </DashboardHeaderRowStyled>
  );
};
